import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import LayoutProvider from "../Providers/LayoutProvider";
import { useSelector, useDispatch } from "react-redux";
import { initialize } from "../Modules/Common/App";

/**
 * Layout - Universal layout wrapper for all routes
 * 
 * @param {string} layout - Layout type to use ('PUBLIC', 'AUTH', 'ERROR', 'OFFICE')
 * @param {boolean} requireAuth - Whether authentication is required (default: false)
 * @param {boolean} fullWidth - Whether to use full width layout (default: false)
 * @param {array} allowedRoles - Roles allowed to access (not yet implemented)
 */
export const Layout = ({ layout, requireAuth = false, fullWidth = false, allowedRoles }) => {
    const dispatch = useDispatch();
    const { isLoggedIn } = useSelector((store) => store.auth);
    const currentMode = useSelector((store) => store.app?.mode);

    // Map layout to reducer mode
    const layoutToMode = {
        'PUBLIC': 'PUBLIC',
        'AUTH': 'PRIVATE',
        'ERROR': 'PUBLIC',
        'OFFICE': 'OFFICE',
        'PRIVATE': 'PRIVATE',
    };

    const targetMode = layoutToMode[layout] || 'PUBLIC';

    // Set mode based on layout - handles all route transitions:
    // 1. Public → Login → Private/Office (after login)
    // 2. Private/Office → Public (visiting homepage while logged in)
    // 3. Any route change automatically updates mode
    useEffect(() => {
        if (currentMode !== targetMode) {
            dispatch(initialize(targetMode));
        }
    }, [layout, targetMode, currentMode, dispatch]);

    // If auth is required but user is not logged in, redirect to login
    if (requireAuth && !isLoggedIn) {
        return <Navigate to="/login" />;
    }

    return (
        <LayoutProvider layout={layout} fullWidth={fullWidth}>
            <Outlet />
        </LayoutProvider>
    );
};
